<div id="resultContent" nz-row>

  <div nz-col nzSpan="4"></div>
  <div nz-col nzSpan="16">
    <nz-card>

      <nz-list nzSplit="true" [nzLoading]="loading">
        
        <nz-list-item *ngFor="let item of proteinList">
          <nz-list-item-meta>
            <nz-list-item-meta-title>
              <a [routerLink]="['/protein_detail', item.id]">{{ item.name }}</a>
            </nz-list-item-meta-title>
            <nz-list-item-meta-description>
              <p class="fullName">{{ item.protein_fullName }}</p>
              <nz-tag [nzColor]="'#87d068'">{{ item.dataset }}</nz-tag>
              <p><span>Accession: </span> {{ item.accession }}</p>
              <p><span>Gene: </span> {{ item.gene_name }}</p>
              <p><span>Organism: </span> <nz-tag [nzColor]="'cyan'">{{ item.organism_scientific_name }}</nz-tag></p>
            </nz-list-item-meta-description>
          </nz-list-item-meta>
        </nz-list-item>

        <nz-list-pagination>
          <nz-pagination *ngIf="!loading" [(nzPageIndex)]="pageIndex" [(nzTotal)]="total" (nzPageIndexChange)="changePage($event)"></nz-pagination>
        </nz-list-pagination>
      </nz-list>
    </nz-card>
  </div>
  <div nz-col nzSpan="4"></div>


</div>
